import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { fadeInLeft } from "react-animations";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;
// Styles
export const MainContainer = styled.div`
  margin: 15px auto;
  padding: 0 20px;
  width: 100%;
  height: 60px;
  max-width: 860px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background-color: #d3d2d2;
  border-radius: 5px;
  @media (max-width: 910px) {
    padding: 10px;
    width: 85%;
  }
`;
export const BackLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  border: none;
  cursor: pointer;
`;
export const ArrowImg = styled.img`
  margin: ${({ margin }) => margin && margin};
  width: 18px;
  height: 18px;
  @media (max-width: 910px) {
    margin: ${({ margin960 }) => margin960 && margin960};
    width: 14px;
    height: 14px;
  }
`;
export const LinkText = styled.p`
  color: #808080;
  font-weight: bold;
  @media (max-width: 910px) {
    font-size: 12px;
  }
`;
export const PreviousAndNextDiv = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const NavigationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;
export const SeparatorDiv = styled.div`
  margin: 0 20px;
  width: 2px;
  height: 60%;
  background-color: #808080;
  @media (max-width: 910px) {
    margin: 0 10px;
  }
`;
export const SessionHeaderMainDiv = styled.div`
  margin: 0 auto 10px;
  width: 100%;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
    max-width: 860px;
  }
`;
export const SessionHeaderDiv = styled.div`
  width: 100%;
  display: flex;
`;
export const SessionTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const SessionHideDiv = styled.div`
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const SessionMainDiv = styled.div`
  margin: 0 auto 10px;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
  }
`;
export const SessionDiv = styled.div`
  height: 50px;
  max-width: 570px;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    height: auto;
    flex-direction: column;
    box-shadow: none;
    background: transparent;
    transition: all 0.5s ease-out;
  }
`;
export const InfoDiv = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 270px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const SessionText = styled.p`
  width: ${({ width }) => width && width};
  font-size: 14px;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const ShowExtraInfoButton = styled.button`
  width: 35px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid #ccc;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const ShowExtraInfoImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const ExtraInfoDiv = styled.div`
  width: auto;
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  @media (max-width: 910px) {
    margin-top: 2px;
    width: 190px;
    height: 60px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    display: ${({ show }) => (show ? "flex" : "none")};
    justify-content: space-around;
    animation: 0.5s ${fadeInDownAnimation};
  }
`;
export const ExtraInfoSessionDiv = styled.div`
  padding: 5px 0 7px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 5px 5px 0;
  @media (max-width: 910px) {
    height: 95%;
  }
`;
export const ExtraInfoSessionTitle = styled.p`
  display: none;
  font-size: 12px;
  font-weight: 600;
  color: #808080;
  @media (max-width: 910px) {
    display: inline;
  }
`;
export const IndicatorDataDiv = styled.div`
  margin: 20px auto;
  padding: 10px;
  width: 100%;
  max-width: 860px;
  background-color: #ccc;
  border-radius: 5px;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const IndicatorDataText = styled.p`
  font-size: 18px;
  color: #fff;
`;
